import React, { useState, useEffect } from 'react';
import videoPote from '../assets/pote-animado.mp4'; 

const SobreProduto = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section style={styles.section}>
      
      {/* --- PARTE 1: O PRODUTO (VÍDEO + TEXTO) --- */}
      <div 
        className="container" 
        style={{
            ...styles.container,
            flexDirection: isMobile ? 'column' : 'row',
            textAlign: isMobile ? 'center' : 'left',
            marginBottom: '60px' // Espaço para separar da próxima parte
        }}
      >
        
        {/* COLUNA DE TEXTO */}
        <div style={{
            ...styles.textContent,
            order: isMobile ? 2 : 1, 
            alignItems: isMobile ? 'center' : 'flex-start'
        }}>
          
          <h2 style={{
              ...styles.headline,
              fontSize: isMobile ? '2rem' : '3rem'
          }}>
            São 24 ingredientes poderosos em <span style={{color: '#FF8C00'}}>1 gummy</span>.
          </h2>
          
          <h3 style={styles.subHeadline}>
             Longevidade começa com cuidado diário.
          </h3>

          <div style={styles.divider}></div>

          <p style={styles.paragraph}>
            A <strong>PAWS Premium Balance Gummy</strong>  é mais do que um suplemento: é um petisco saudável criado para facilitar a 
            rotina e oferecer suporte completo à saúde do pet. 
          </p>
          
          <p style={styles.paragraph}>
            É prática, saborosa e <span style={{color: '#32CD32', fontWeight: 'bold'}}>100% segura</span>.
          </p>

          <p style={styles.paragraph}>
            Desenvolvida por especialistas, sua fórmula foi pensada para restaurar, cuidar e prevenir, de forma leve e prazerosa para o tutor e o cão.
          </p>

        </div>

        {/* COLUNA DO VÍDEO NO CÍRCULO */}
        <div style={{
            ...styles.imageContent,
            order: isMobile ? 1 : 2, 
            marginBottom: isMobile ? '40px' : '0'
        }}>
          
          <div style={styles.videoMask}>
            <video 
              src={videoPote} 
              autoPlay 
              loop 
              muted 
              playsInline
              style={styles.videoStyle}
            />
          </div>

        </div>

      </div>

      {/* --- PARTE 2: É PARA TODOS? (AGORA SEM O QUADRO) --- */}
      <div style={styles.paraTodosContainer}>
          <h2 style={styles.titleParaTodos}>
            <center>A Gummy é para todos os cachorros?</center>
          </h2>
          
          <p style={styles.paragraphCenter}>
            Sim! A Premium Balance Gummy 24 em 1 foi desenvolvida para cães de todas as raças,portes e idades, oferecendo nutrição completa, prática e segura. Com fórmula exclusiva que reúne 24 ingredientes essenciais em uma única gummy, ela cuida da saúde do seu pet de dentro para fora — fortalecendo, equilibrando e prevenindo. 
          </p>
          
      </div>

    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#FFF8F0', 
    padding: '80px 20px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column', // MUDANÇA: Coloca um bloco embaixo do outro
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center', 
    justifyContent: 'space-between',
    gap: '60px',
  },
  textContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  imageContent: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  headline: {
    color: '#513D8B', 
    fontFamily: '"Titan One", sans-serif',
    lineHeight: '1.1',
    marginBottom: '15px',
    textTransform: 'uppercase'
  },
  subHeadline: {
    color: '#513D8B',
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1.5rem',
    fontWeight: '600',
    marginBottom: '20px',
    opacity: '0.9'
  },
  divider: {
    width: '80px',
    height: '6px',
    backgroundColor: '#FF8C00', 
    borderRadius: '10px',
    marginBottom: '30px'
  },
  paragraph: {
    color: '#555',
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1.1rem',
    lineHeight: '1.6',
    marginBottom: '20px',
    maxWidth: '500px'
  },

  // --- ESTILOS DO VÍDEO ---
  videoMask: {
    width: '450px', 
    height: '450px',
    borderRadius: '50%', 
    overflow: 'hidden', 
    position: 'relative',
    zIndex: 2,
    border: '5px solid #fff', 
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    backgroundColor: '#E6E0F8' 
  },
  videoStyle: {
    width: '100%',
    height: '100%',
    objectFit: 'cover', 
  },

  // --- ESTILOS NOVOS PARA O BLOCO "PARA TODOS" ---
  paraTodosBox: {
    maxWidth: '900px',
    width: '100%',
    backgroundColor: '#fff', // Fundo branco para destacar do fundo bege da seção
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.05)', // Sombra suave
    textAlign: 'center',
    marginTop: '20px',
    border: '2px solid #F5DEB3' // Borda bege escura sutil
  },
  titleParaTodos: {
    color: '#397449', // Verde para variar a cor
    fontSize: '2rem',
    fontFamily: '"Titan One", sans-serif',
    marginBottom: '20px',
    textTransform: 'uppercase'
  },
  paragraphCenter: {
    color: '#555',
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1.1rem',
    lineHeight: '1.6',
    marginBottom: '15px',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto'
  }
};

export default SobreProduto;